import getStore from '../store/store';

export default function getTextPredictionEnabled() {
    return getStore().userOptions.textPredictionEnabled;
}
